import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { FrontOfficeCommonModule } from '@dcs-workspace/front-office/common';
import { AppComponent } from './app.component';
import {
  ApmErrorHandler,
  ApmService,
  SharedModule,
} from '@dcs-workspace/shared';
import { AppRoutingModule } from './app-routing.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreRouterConnectingModule, routerReducer } from '@ngrx/router-store';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { Router } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {sharedReducer} from "@dcs-workspace/shared";
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    FrontOfficeCommonModule,
    StoreModule.forRoot({
      router: routerReducer,
    }),
    StoreModule.forFeature('shared', sharedReducer),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument(),
    StoreRouterConnectingModule.forRoot(),
    ReactiveFormsModule,
    FormlyModule.forRoot({ extras: { lazyRender: true } }),
  ],
  providers: [
    {
      provide: ApmService,
      useClass: ApmService,
      deps: [Router],
    },
    {
      provide: ErrorHandler,
      useClass: ApmErrorHandler,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
